/* eslint-disable prettier/prettier */

<script>
import MemberReporting from "../views/MemberReporting";
import SecretariatReporting from "../views/SecretariatReporting";
import Closure from "../views/Closure";

export default {
  name: "ViewOutcome",
  components: {
    MemberReporting,
    SecretariatReporting,
    Closure
  },
  data: function() {
    return {
      apiUrl: process.env.VUE_APP_API_PATH,
      id: 0,
      processingMessage: "",
      modelData: [],
      updateMemberStatesText: "Update",
      updateSecritariatText: "Update",
      primaryID: [],
      collapseStates: [false],
      secondaryID: []
    };
  },
  computed: {
    showMemberStateReport() {
      if (!this.getShowUpdate) {
        return false;
      }

      let loggedInUniteId = document.getElementById("loggedInUniteId");
      if (loggedInUniteId != null && loggedInUniteId.value == "0") {
        return true;
      }

      if (
        loggedInUniteId == null &&
        window.location.href.indexOf("localhost") >= 0
      ) {
        return true;
      }

      return false;
    },
    showSecretariatReport() {
      console.log(this.getShowUpdate);
      if (!this.getShowUpdate) {
        return false;
      }

      if (
        loggedInUniteId == null &&
        window.location.href.indexOf("localhost") >= 0
      ) {
        return true;
      }

      let loggedInUniteId = document.getElementById("loggedInUniteId");
      if (loggedInUniteId != null && loggedInUniteId.value == "1") {
        // eslint-disable-next-line no-unused-vars
        let loggedInUserId = document.getElementById("loggedInUserId").value;
        let loggedInUserEmail = document.getElementById("loggedInUserEmail").value;
        loggedInUserEmail = loggedInUserEmail.toLowerCase();
        loggedInUserId = loggedInUserId.toLowerCase();

        console.log(this.primaryID);
        console.log(this.primaryID.includes(loggedInUserEmail));
        console.log(this.secondaryID);
        console.log(this.secondaryID.includes(loggedInUserEmail));
        if (
          this.primaryID.includes(loggedInUserEmail) ||
          this.secondaryID.includes(loggedInUserEmail)
        ) {
          return true;
        }

        if (this.primaryID.length == 0 && this.secondaryID.length == 0) {
          return false;
        }
      }

      return false;
    },
    getShowEdit() {
      // let loggedInUniteId = document.getElementById("loggedInUniteId");
      // if (loggedInUniteId != null && loggedInUniteId.value !== "1") {
      //   return true;
      // }

      // if (loggedInUniteId != null && loggedInUniteId.value == "1") {
      //   let isadmin = document.getElementById("loggedInUserIsAdmin").value;
      //   // eslint-disable-next-line no-unused-vars
      //   let loggedInUserId = document.getElementById("loggedInUserId").value;
      //   let loggedInUserEmail = document.getElementById("loggedInUserEmail")
      //     .value;
      //   loggedInUserEmail = loggedInUserEmail.toLowerCase();
      //   loggedInUserId = loggedInUserId.toLowerCase();

      //   console.log(this.primaryID);
      //   console.log(this.primaryID.includes(loggedInUserEmail));
      //   console.log(this.secondaryID);
      //   console.log(this.secondaryID.includes(loggedInUserEmail));
      //   if (
      //     this.primaryID.includes(loggedInUserEmail) ||
      //     this.secondaryID.includes(loggedInUserEmail)
      //   ) {
      //     return false;
      //   }

      //   if (
      //     this.primaryID.length == 0 &&
      //     this.secondaryID.length == 0 &&
      //     isadmin != "1"
      //   ) {
      //     return true;
      //   }
      //}

      // return false;
      // to only allow admins to edit outcomes
        let isadmin = document.getElementById("loggedInUserIsAdmin").value;
        // let loggedInUniteId = document.getElementById('loggedInUniteId');
        if (isadmin != "1") {
          return true;
        }
        return false;
    },
    getShowDelete() {
      let isadmin = document.getElementById("loggedInUserIsAdmin").value;
      // let loggedInUniteId = document.getElementById('loggedInUniteId');
      if (isadmin != "1") {
        return true;
      }

      return false;
    },
    getShowUpdate() {
      let isreporter = document.getElementById("loggedInUserIsReporter").value;
      if (isreporter == "1") {
        return true;
      }

      return false;
    }
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.fetchData();
    document.getElementById("current_location").value = 'outcomesLinkButton';
  },
  methods: {
    deleteOutcome() {
      if (confirm("Are you sure you want to delete this outcome?")) {
        this.processingMessage =
          "<span style='color: orange;'>Deleting outcome ...</span>";
        let url = this.apiUrl + "/deleteoutcome/" + this.id;
        fetch(url, {
          method: "post",
          headers: { "Content-Type": "application/json" }
        })
          .then(res => {
            if (!res.ok) {
              throw new Error("HTTP status " + res.status);
            }
            return res.json();
          })
          .then(res => {
            if (res.success) {
              this.processingMessage =
                "<span style='color: green;'>Outcome has been deleted successfully.</span>";
              setTimeout(() => {
                this.processingMessage = "";
                this.$router.push("/outcomes");
              }, 1000);
            } else {
              this.processingMessage =
                "<span style='color: red;'>Error occurred: " +
                res.message +
                "</span>";
            }
          })
          .catch(error => {
            this.processingMessage =
              "<span style='color: red;'>Error occurred: " + error + "</span>";
          });
      }
    },
    fetchData() {
      let url = this.apiUrl;
      fetch(url + "/getoutcome?id=" + this.id)
        .then(res => res.json())
        .then(res => {
          this.modelData = res["data"];
          this.primaryID = [];
          res["data"]["primary_reporter"].forEach(element => {
            this.primaryID.push(element["reporter_email"].toLowerCase());
          });
          this.secondaryID = [];
          res["data"]["secondary_reporter"].forEach(element => {
            this.secondaryID.push(element["reporter_email"].toLowerCase());
          });
        })
        .then(items => items);
    }
  }
};
</script>
<template>
  <div class="myviewoutcome col-md-12" style="margin-bottom: 50px;">
    <b-container>
      <b-row>
        <b-col sm="1"> </b-col>
        <b-col sm="10">
          <b-container fluid class="">
            <b-row class="">
              <b-col md="9"> </b-col>
              <b-col md="3" class="" style="">
                <b-form-group v-bind:hidden="getShowEdit">
                  <b-row class="">
                    <b-button
                      block
                      v-bind:hidden="getShowEdit"
                      size="lg"
                      :to="{ name: 'addoutcome', params: { id: id } }"
                      variant="outline-none"
                      class="align-items-center d-flex justify-content-center"
                      style="border-radius: unset; border: none; outline:none; background-color:#91C85F; font-size:17px; font-weight:600; color:dark;"
                    >
                      <b-icon-pencil></b-icon-pencil> Edit
                    </b-button>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="" style="">
              <b-col sm="9"> </b-col>
              <b-col sm="3" class="" style="">
                <b-form-group v-bind:hidden="getShowDelete">
                  <b-row class="">
                    <b-button
                      block
                      v-bind:hidden="getShowDelete"
                      size="lg"
                      @click="deleteOutcome"
                      variant="outline-none"
                      style="border-radius: unset; border: none; outline:none; background-color:#565754; font-size:17px; font-weight:600; color:white;"
                      class="align-items-center d-flex justify-content-center"
                    >
                      <b-icon-trash variant="light"></b-icon-trash> Delete
                    </b-button>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6"> </b-col>
              <b-col sm="6">
                <span style="" v-html="processingMessage"></span>
              </b-col>
            </b-row>
          </b-container>
          <b-tabs
            justified
            content-class="mt-3 mb-5"
            style="border-bottom: none;"
          >
            <b-tab active style="border-bottom:none" border-variant="light">
              <template v-slot:title style="border-bottom:none;">
                <div class="col" style="border-bottom:none;">
                  <h6
                    class="mt-3"
                    style="font-weight: 600; color:#1D1D1D; font-family:Roboto; font-size:22px;"
                  >
                    Outcome Overview
                  </h6>
                </div>
              </template>
              <b-col sm="">
                <b-row
                  class="col-header align-items-center d-flex justify-content-left"
                  style="font-weight:normal; font-size:1.45em; background-color:#565754;"
                >
                  <b-col sm="1"> </b-col>
                  <b-col sm="10">
                    <b-row>
                      <b-col sm="12" class="mt-3 mb-1">
                        <h4
                          class="mheader "
                          style="font-family:Roboto; font-size: 22px; font-color:white;"
                        >
                          <span
                            class=""
                            style="color:white;" 
                            v-html="this.modelData['outcome_type_model']['outcome_type'] +'</br> ' + this.modelData['model']['outcome_code'] + ': ' + this.modelData['model']['outcome_name']"/>
                        </h4>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="1"> </b-col>
                </b-row>
                <b-row class="" style="background-color:#F4F4F4;">
                  <b-col sm="1"> </b-col>
                  <b-col sm="10">
                    <b-row>
                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #565754; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; font-weight: 600; font-size: 18px;"
                          aria-expanded="true"
                          block
                          v-b-toggle.accordion-1
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">Summary</span>
                          <strong
                            v-if="collapseStates[0]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-1"
                          v-model="collapseStates[0]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h5>
                          <p
                            class="mt-3 ml-3"
                            style="font-family:roboto; font-size:17px;"
                            v-html="modelData['model']['outcome_summary']"
                          ></p>
                        </b-collapse>
                      </div>
                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-2
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">
                            Executive Director's Mandate</span
                          >
                          <strong
                            v-if="collapseStates[1]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-2"
                          v-model="collapseStates[1]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h5>
                          <p
                            class="mt-3 ml-3"
                            style="font-family:roboto; font-size:17px;"
                            v-html="modelData['model']['ed_mandate']"
                          ></p>
                        </b-collapse>
                      </div>

                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-3
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3"
                            >Member State Actions Required</span
                          >
                          <strong
                            v-if="collapseStates[2]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-3"
                          v-model="collapseStates[2]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h5>
                          <p
                            class="mt-3 ml-3"
                            style="font-family:roboto; font-size:17px;"
                            v-html="modelData['model']['actions_required']"
                          ></p>
                        </b-collapse>
                      </div>

                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-4
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3"
                            >Contributions to Higher Goals (SDGs)</span
                          >
                          <strong
                            v-if="collapseStates[3]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-4"
                          v-model="collapseStates[3]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px; "
                          ></h5>
                          <div class="mt-3" style="">
                            <div
                              class=""
                              v-if="modelData['sdg_outcome'].length == 0"
                            >
                              <span style="font-size:17px;">NO SDGs</span>
                            </div>
                            <b-row>
                              <b-col
                                class="column_wrapper"
                                style="column-count:4"
                              >
                                <b-card-text
                                  v-for="item in modelData['sdg_outcome']"
                                  :key="item.id"
                                  style="font-family:roboto; font-size:17px;"
                                  class=""
                                >
                                  <span
                                    ><img
                                      :src="item.image"
                                      style="width: 60%;"/></span
                                  ><br />
                                </b-card-text>
                              </b-col>
                            </b-row>
                          </div>
                        </b-collapse>
                      </div>
                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-5
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">SDGs Targets</span>
                          <strong
                            v-if="collapseStates[4]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-5"
                          v-model="collapseStates[4]"
                        >
                          <h6
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h6>
                          <ul class="mt-3" style="">
                            <li v-if="modelData['target_outcome'].length == 0">
                              <span style="font-size:17px;"
                                >NO SDGs Targets</span
                              >
                            </li>
                            <li
                              v-for="item in modelData['target_outcome']"
                              :key="item.id"
                              style="font-family:roboto; font-size:17px;"
                            >
                              {{ item.target }}
                            </li>
                          </ul>
                        </b-collapse>
                      </div>
                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-6
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">SDGs Indicators</span>
                          <strong
                            v-if="collapseStates[5]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-6"
                          v-model="collapseStates[5]"
                        >
                          <h6
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h6>
                          <ul class="mt-3" style="">
                            <li v-if="modelData['ind_outcome'].length == 0">
                              <span style="font-size:17px;"
                                >NO SDGs Indicators</span
                              >
                            </li>
                            <li
                              v-for="item in modelData['ind_outcome']"
                              :key="item.id"
                              style="font-family:roboto; font-size:17px;"
                            >
                              {{ item.ind }}
                            </li>
                          </ul>
                        </b-collapse>
                      </div>

                      <div class="col-md-12 mt-3">
                        <b-button
                          block
                          v-b-toggle.accordion-7
                          class="d-flex mt-2"
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                        >
                          <span class="ml-n3">Link to Programme of Work</span>
                          <strong
                            v-if="collapseStates[6]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-7"
                          v-model="collapseStates[6]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:22px;"
                          ></h5>
                          <ul class="mt-3" style="">
                            <li v-if="modelData['pow_outcome'].length == 0">
                              <span style="font-size:17px;">NO PoWs</span>
                            </li>
                            <li
                              v-for="item in modelData['pow_outcome']"
                              :key="item.id"
                              style="font-family:roboto; font-size:17px;"
                            >
                              {{ item.pow }}
                            </li>
                          </ul>
                        </b-collapse>
                      </div>

                      <div class="col-md-12 mt-3">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-8
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">Link to Projects</span>
                          <strong
                            v-if="collapseStates[7]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-8"
                          v-model="collapseStates[7]"
                        >
                          <h5
                            class="mheader"
                            style="font-family:Roboto; font-weight:600; font-size:17px;"
                          ></h5>
                          <ul class="mt-3" style="">
                            <li v-if="modelData['project_outcome'].length == 0">
                              <span style="font-size:17px;">No Projects</span>
                            </li>
                            <li
                              v-for="item in modelData['project_outcome']"
                              :key="item.id"
                              style="font-family:roboto; font-size:17px;"
                            >
                              {{ item.project }}
                            </li>
                          </ul>
                        </b-collapse>
                      </div>
                      <div class="col-md-12 mt-3 mb-5">
                        <b-button
                          style="border-color: #6c757d; border-bottom: 2px solid #565754; background-color: #F4F4F4; color: #1D1D1D; outline: none; text-align: left; font-weight: 600; font-size: 18px;"
                          block
                          v-b-toggle.accordion-9
                          class="d-flex mt-2"
                        >
                          <span class="ml-n3">Download PDF</span>
                          <strong
                            v-if="collapseStates[8]"
                            aria-expanded="true"
                            class="ml-auto"
                            >-</strong
                          >
                          <strong
                            v-else
                            aria-expanded="true"
                            class="ml-auto"
                            style="text-align:right;"
                            >+</strong
                          >
                        </b-button>
                        <b-collapse
                          id="accordion-9"
                          v-model="collapseStates[8]"
                        >
                          <b-col
                            sm="2"
                            style=""
                            class="mt-2 align-items-center d-flex justify-content-right"
                            v-bind:hidden="
                              this.modelData.model.outcome_link == null
                            "
                          >
                            <a
                              :href="modelData.model.outcome_link"
                              target="_BLANK"
                              ><img
                                src="../assets/pdf.png"
                                style="width: auto; height:60px; text-align:right;"
                                class="align-items-center d-flex justify-content-right"
                            /></a>
                          </b-col>
                        </b-collapse>
                      </div>
                    </b-row>
                  </b-col>
                  <b-col sm="1"> </b-col>
                </b-row>
              </b-col>
            </b-tab>
            <span v-if="showMemberStateReport">
              <b-tab lazy border-variant="light">
                <template v-slot:title>
                  <h5
                    class="mt-3"
                    style="font-weight: 600; color:#1D1D1D; font-family:Roboto;"
                  >
                    Update Member States
                  </h5>
                </template>
                <MemberReporting />
              </b-tab>
            </span>
            <span v-if="showSecretariatReport">
              <b-tab lazy style="">
                <template v-slot:title style="border-bottom:none;">
                  <h6
                    class="mt-3"
                    style="font-weight: 600; color:#1D1D1D; font-family:Roboto; font-size:22px;"
                  >
                    Update Secretariat
                  </h6> 
                </template>
                <SecretariatReporting />
              </b-tab>
            </span>
            <span v-if="showSecretariatReport">
              <b-tab lazy style="">
                <template v-slot:title style="border-bottom:none;">
                  <h6
                    class="mt-3"
                    style="font-weight: 600; color:#1D1D1D; font-family:Roboto; font-size:22px;"
                  >
                    Resolutions Closure
                  </h6>
                </template>
                <Closure />
              </b-tab>
            </span>
          </b-tabs>
        </b-col>
        <b-col sm="1"> </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<style>
.mheader {
  font-size: large;
}
.container {
  max-width: 1278px !important;
}
.myviewoutcome {
  margin: auto !important;
  min-height: 100%;
  position: relative;
}
.nav-tabs {
  border-bottom: 0px solid #dee2e6 !important;
}
.nav-tabs .nav-item {
  border-left: 3px solid white !important;
  text-align: center;
  background-color: #ebebeb;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border: 4px solid #91c85f !important;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > i.active > a:focus {
  border-bottom-color: #ffffff !important;
}
.col-header {
  height: auto !important;
}
.btn-secondary {
  border-radius: unset !important;
  border-top-color: #f4f4f4 !important;
  border-right-color: #f4f4f4 !important;
  border-left-color: #f4f4f4 !important;
}
.btn-block {
  display: inline-block;
  width: 100% !important;
  min-height: 56px;
}
.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
  box-shadow: none !important;
}
.column_wrapper {
  column-count: 2;
}
.nav-tabs .nav-link {
  border: none !important;
}
.nav-item {
  font-size: small !important;
  background-color: rgb(235 235 235) !important;
  border-bottom: none;
}
</style>
